import { useCallback } from "react";
import UserVideoDisplay from "../../UserVideoDisplay/userVideoDisplay";
import Avatar from "@components/profile/avatar";
import CurrentUserVideo from "../../user-video/user-video";
import { ILayoutVideosProps } from "../multi-videos";
import { ILocalVideoTrack } from "agora-rtc-sdk-ng";

const Basic = (props: ILayoutVideosProps) => {
    const {
        users,
        tracks,
        start,
        userList,
        myUsername,
        showVideo,
        ownTrack,
        getUsername,
        getCurrentUser
    } = props;

    const getClassnameLayout = useCallback(() => {
        //We add +1 because our own track is only in local, is not part of users' array
        const usersLength = users.length + 1
        switch(usersLength){
            case 3:
            case 6:
                return "VideoCall__GroupGrid-3-6"
            case 5:
                return "VideoCall__GroupGrid-5"
            default:
                return "VideoCall__GroupGrid-1-2-4"
        }
    }, [users])

    return (
        <>
            {/* Next conditional is used to show own video track or avatar */}
            {users.length <= 1 ?
                start && tracks && tracks.length > 0 ?
                    <div className="VideoCall__InfoYou">
                        <CurrentUserVideo
                            videoTrack={ownTrack() as ILocalVideoTrack}
                            username={myUsername}
                            size={120}
                            showVideo={showVideo} />
                        <div className="VideoCall__MiniInfoName">
                            <em className="fas fa-user" />
                            <p className="VideoCall__MiniInfoNameText"> {getUsername(myUsername)} </p>
                        </div>
                    </div>
                    :
                    <div className="VideoCall__InfoYou">
                        <div className="VideoCall__Avatar">
                            <Avatar
                                username={myUsername}
                                roleCode="PR"
                                size={30}
                                editable={false}
                            />
                            <div className="VideoCall__MiniInfoName">
                                <em className="fas fa-user" />
                                <p className="VideoCall__MiniInfoNameText"> {getUsername(myUsername)} </p>
                            </div>
                        </div>
                    </div>
                : null
            }
            <div className={getClassnameLayout()}>
                {/* Own Video */}
                {users.length > 1 ?
                    start && tracks && tracks.length > 0 &&
                        <UserVideoDisplay
                            username={getUsername(myUsername)}
                            size={30}
                            track={ownTrack()}
                            key={getUsername(myUsername)}
                            roleCode="PR"
                        />
                    :
                    null
                }
                {userList.length > 0 && userList.map((username, index) => {
                    const user = getCurrentUser(username)
                    return (
                        <UserVideoDisplay
                            user={user}
                            username={username}
                            size={120}
                            key={username}
                            roleCode="PR"
                        />
                    )
                })
                }
            </div>
        </>
    );
};

export default Basic;
